import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User imported an Air asset into Premiere',
  name: 'premiere_imported_asset',
  params: [
    {
      description: 'The id of the imported clip/version',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the imported asset',
      name: 'asset_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The file name of the imported asset',
      name: 'file_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
